import moment from "moment";
import React, { useEffect } from "react";
import TableWrap from "../Common/Table/Table";
import PageHeader from "../PageHeader";
import usePayAxios from "../../config/useAxios";

const Activity = () => {
  const [page, setPage] = React.useState(1);
  const [filters, setFilters] = React.useState({});
  const {
    onCall: getActivityOnCall,
    data: getActivityData,
    loading: getActivityLoading,
  } = usePayAxios({
    api: "/api/login-activities/v1/list",
    method: "get",
    showSuccessMessage: false,
  });
  const columns = [
    {
      title: "Event",
      dataIndex: "event",
      key: "event",
    },
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
    },
    {
      title: "IP Address",
      dataIndex: "ip_address",
      key: "ip_address",
    },
    {
      title: "Date and Time",
      dataIndex: "date_time",
      key: "date_time",
      render: (text) =>
        text ? moment(text).format("DD-MM-YYYY, HH:mm:ss") : "",
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
    },
  ];

  useEffect(() => {
    getActivityOnCall({ params: { ...filters, page: 1 } });
  }, []);

  const handleSearch = (value) => {
    const newFilters = {
      ...filters,
      search: value,
      source: "admin",
    };
    setFilters(newFilters);
    // getActivityOnCall({ params: { ...filters, page: 1, search: value, source: "admin" } })
    // setFilters({
    //     ...filters,
    //     search: value,
    // });
    setPage(1);
    getActivityOnCall({ params: { ...newFilters, page: 1 } });
  };

  return (
    <div>
      <div className="heading-div">
        <PageHeader
          title={`Activity history`}
          navigation={{
            Home: "/",
          }}
        />
      </div>
      <TableWrap
        rowKey="id"
        className="tableStyled admin cards"
        columns={columns}
        data={
          Array.isArray(getActivityData?.response?.login_activities)
            ? getActivityData?.response?.login_activities
            : []
        }
        placeholder={"Search..."}
        pagination={{
          total: getActivityData?.total_records || 0,
          current: page,

          onChange: (pagee) => {
            // getActivityOnCall({ params: { page: pagee } })
            getActivityOnCall({ params: { ...filters, page: pagee } });
            setPage(pagee);
          },
        }}
        isTopFilter={true}
        filter={false}
        filterMenu={true}
        isMore={true}
        handleSearch={handleSearch}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default Activity;
